import { bolNumber } from './bol-number';
import { proNumber } from './pro-number';
import { carrier } from './carrier';
import { origin } from './origin';
import { destination } from './destination';
import { shipDate } from './ship-date';
import { weight } from './weight';
import { charges } from './charges';
import { quoteExpiration } from './quote-expiration';
import { status } from './status';

export const defaultFreightColumns = [
  bolNumber,
  proNumber,
  carrier,
  origin,
  destination,
  shipDate,
  weight,
  charges,
  quoteExpiration,
  status,
];
